class Recruit {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.handleScroll();
  }
  
  handleScroll() {
    const recruitBtn = $('.recruit-btn');
    
    $(window).on('scroll', () => {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const documentHeight = $(document).height();
      
      // ページ一番上から200px下にスクロールしたらis-activeを付与
      if (scrollTop >= 200) {
        recruitBtn.addClass('is-active');
      } else {
        recruitBtn.removeClass('is-active');
      }
      
      // ページ一番下から300px上の位置まで移動したらis-activeを外す
      // スマートフォン幅の時は600px
      const isMobile = window.innerWidth <= 768;
      const bottomOffset = isMobile ? 900 : 300;
      
      if (scrollTop + windowHeight >= documentHeight - bottomOffset) {
        recruitBtn.removeClass('is-active');
      }
    });
  }
}